import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';

type DeleteRecordProps = {
  closeModal: () => void;
  onDelete: () => void;
  deleteMessage: string;
  deleteTitle: string;
  familyTrees?: any[];
};
export default function DeleteModal({
  closeModal,
  onDelete,
  deleteMessage,
  deleteTitle,
  familyTrees = [],
}: DeleteRecordProps) {
  const navigate = useNavigate();
  function handleOnDeleteMember() {
    if (onDelete) {
      onDelete();
    }
  }
  return (
    <Box p={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
        <Typography variant="h5">{deleteTitle}</Typography>
        <IconButton onClick={closeModal}>
          <ClearIcon />
        </IconButton>
      </Box>
      <Box py={1}>
        <Typography variant="body1">{deleteMessage}</Typography>
      </Box>
      {familyTrees.length > 0 && (
        <Box p={2}>
          <Typography variant="body1" color="textSecondary">
            You have family trees associated with your account. Please delete
            them before proceeding.
          </Typography>
          <Box p={2}>
            <ul>
              {familyTrees?.map((tree) => (
                <li key={tree.id}>
                  <Typography
                    variant="body2"
                    color="warning"
                    sx={{
                      cursor: 'pointer',
                      ':hover': { textDecoration: 'underline' },
                    }}
                    onClick={() => {
                      navigate(`/app/tree/${tree.id}`);
                      closeModal();
                    }}
                  >
                    {tree.name}
                  </Typography>
                </li>
              ))}
            </ul>
          </Box>
        </Box>
      )}
      <Box
        py={2}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          alignItems: 'center',
        }}
      >
        <Button variant="outlined" onClick={closeModal}>
          No
        </Button>
        <Button
          variant="contained"
          disabled={familyTrees.length > 0}
          onClick={handleOnDeleteMember}
          color="error"
        >
          Yes
        </Button>
      </Box>
    </Box>
  );
}
